define('uikit/modules/input.counter',['require','exports','module','backbone','marionette','underscore','../mixins/component.mixin','../elements/input','../elements/button','../channel','templates','../helper/is.ignored.key'],function(require, exports, module) {
  //prettier-ignore
  var Backbone   = require('backbone'),
  Mn             = require('marionette'),
  _              = require('underscore'),
  ComponentMixin = require('../mixins/component.mixin'),
  InputView      = require('../elements/input'),
  ButtonView     = require('../elements/button'),
  channel        = require('../channel'),
  Templates      = require('templates'),
  isIgnoredKey   = require('../helper/is.ignored.key');

  var NumberInput = InputView.extend({
    options: _.extend({}, InputView.prototype.options, {
      inputType: 'number',
      allowNegative: false,
      max: null,
    }),

    forceUpdate: _.extend({}, InputView.prototype.forceUpdate, {
      inputType: true,
    }),

    events: _.extend({}, InputView.prototype.events, {
      // Needed for invalid chrome behavior,
      // where an invalid entry returns an empty string
      'blur input': function(ev) {
        this.ui.input.val(this.ui.input.val());
      },

      //Ensure a user can enter ONLY numeric characters across all browsers
      'keypress input': function(ev) {
        //Some keys are "utility" keys (shift, backspace, etc) which some browsers "allow" in number fields and we
        // don't want those to trigger an event.
        if (isIgnoredKey(ev.key)) {
          return;
        }

        // For consistency of UX across all browser platforms, we are suppressing all non-ignored, restricted keys
        if (this._isRestrictedKey(ev.key)) {
          this._triggerInvalidInputEvent(ev.key);
          ev.preventDefault();
          return false;
        }
      },

      //Prevent users from pasting invalid data.
      'paste input': function(ev) {
        var pasteBuffer = (ev.originalEvent.clipboardData || window.clipboardData).getData('text'); //get the past buffer from the clipboard API
        var strippedPasteBuffer = pasteBuffer.replace(/\D/g, ''); //remove any nonnumeric characters from the paste buffer

        //if the pasteBuffer and stripped pastebuffer are not the same, that means a user tried to paste nonnumeric characters.  We
        // do not allow that, so we are going to swallow their attempt and trigger an invalid input event so the UI can warn the user if desired.
        // If a user is pasting integers, they will be allowed to paste
        if (pasteBuffer !== strippedPasteBuffer) {
          this._triggerInvalidInputEvent(pasteBuffer);
          ev.preventDefault();
          return false;
        }
      },
    }),

    _isRestrictedKey: function(key) {
      var ALLOWED_KEYS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-'];

      return ALLOWED_KEYS.indexOf(key) === -1;
    },

    //Trigger an invalid input event. Passes the invalid text and an error message as the arguments
    _triggerInvalidInputEvent: function(invalidText, errorMessage) {
      errorMessage = errorMessage || 'Nonnumeric values are not allowed in a numeric input field';
      this.triggerMethod('input:text:invalid', invalidText, errorMessage);
    },

    updateAttributes: function() {
      InputView.prototype.updateAttributes.apply(this, arguments);

      if (this.getBoolOption('allowNegative')) {
        this.ui.input.prop('min', -Infinity);
      } else {
        // Only allow for positive numbers
        this.ui.input.prop('min', 0);
      }

      if (this.getBoolOption('max')) {
        this.ui.input.prop('max', this.getOption('max'));
      }
    },

    setMaxProperty: function(max) {
      this.max = max;
    },
  });

  var IncrementButton = ButtonView.extend({
    className: 'ui increment button',

    options: _.extend({}, ButtonView.prototype.options, {
      icon: 'angle up',
      basic: true,
    }),
  });

  var DecrementButton = ButtonView.extend({
    className: 'ui decrement button',

    options: _.extend({}, ButtonView.prototype.options, {
      icon: 'angle down',
      basic: true,
    }),
  });

  var Counter = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui counter',

    template: Templates.App['input.counter'],

    options: {
      disabled: false,
      fluid: false,
      readonly: false,
      model: null,
      allowNegative: false,
      value: null,
    },

    internalViewOptions: {
      input: {
        type: NumberInput,
      },
      increment: {
        type: IncrementButton,
      },
      decrement: {
        type: DecrementButton,
      },
    },

    internalViewBindings: {
      input: {
        allowNegative: 'allowNegative',
        disabled: 'disabled',
        fluid: 'fluid',
        readonly: 'readonly',
        value: 'value',
        model: 'model',
      },
    },

    onFirstRender: function() {
      this._updateCounterControls();

      this._counterSetupListeners();
    },

    _counterSetupListeners: function() {
      var input = this.input;

      this.listenTo(this.increment, 'press', function() {
        var value = parseInt(input.value);

        input.value = _.isNaN(value) ? 1 : ++value;
      }).listenTo(this.decrement, 'press', function() {
        var value = parseInt(input.value);

        if (_.isNaN(value)) {
          value = 0;
        } else if (!this.allowNegative && value == 0) {
          value = 0;
        } else {
          --value;
        }

        input.value = value;
      });
    },

    _updateCounterControls: function() {
      var disabled = this.getBoolOption('disabled'),
        readonly = this.getBoolOption('readonly');

      this.increment.disabled = disabled || readonly;
      this.decrement.disabled = disabled || readonly;
    },

    onChangeDisabled: function() {
      this._updateCounterControls();
    },

    onChangeReadonly: function() {
      this._updateCounterControls();
    },

    updateAttributes: function() {
      this.addClass('fluid', this.getBoolOption('fluid'));
    },
  });

  channel.reply('input-counter', function() {
    return Counter;
  });

  module.exports = Counter;
});

